import { render, staticRenderFns } from "./Paggination.vue?vue&type=template&id=176c5ea9&"
import script from "./Paggination.vue?vue&type=script&lang=js&"
export * from "./Paggination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports